<template lang="pug">
  //- wrapper indispensable
  div
    PageTransitionLayer(:backgroundColor="COLOR.DARK" :speed="SPEED.NORMAL/4*3" :delay="SPEED.NORMAL/3")
    CoverSection.Home(v-if="!isTransitioning" backgroundColor="transparent")
      template(slot="background")
        BackgroundRelief

      HomeSearchResults(
        :searchMode="searchMode"
        :previewResults="samples"
        @mouseenterItem="mouseenterItemHandler"
        @mouseleaveItem="mouseleaveItemHandler"
        @selectedItemUpdate="selectedItemUpdateHandler"
        @scrollProgressChanged="scrollProgressChangedHandler"
        @transitionSearchModeCompleted="transitionSearchModeCompletedHandler"
        ref="resultsList"
      )

      div.Home_content(v-if="!searchMode && isPageContentInit")

        PageTitle(:top="currentItem.type", :title="(currentItem && !searchMode) ? currentItem.name : ''", :bottom="$t('home.sample', { number: currentItem.number })", v-if="currentItem")

        router-link(:to="tour.href", v-if="tour" ref="discoverLink").DiscoverLink
          p.DiscoverLink_title {{ $t('home.promoted_tour') }}
          .sep
          p.DiscoverLink_value {{ tour.title }}
          SvgInline(src="round-sep")

        a(href="https://www.unilasalle.fr/", target="_blank").UnilasalleLogo(ref="unilasalleLogo")
          SvgInline(src="unilasalle-logo")

        ScrollIndicator(:progress="scrollProgress")

        FooterDonation(theme="light" ref="footerDonation")
</template>

<script>
import Vue from 'vue'

import { mapGetters, mapActions } from 'vuex'
import SampleModel from '@/models/SampleModel'
import SvgInline from '@/components/SvgInline'
import FooterDonation from '@/components/FooterDonation'
import BackgroundRelief from '@/components/common/BackgroundRelief'
import PageTitle from '@/components/common/PageTitle'
import CoverSection from '@/components/common/CoverSection'
import customTransitionMixins from '@/mixins/customTransitionMixins'
import PageTransitionLayer from '@/components/PageTransitionLayer'
import SearchListResults from '@/components/SearchListResults'
import SPEED from '@/const.speeds.js'
import COLOR from '@/const.colors.js'
import { TweenLite, TimelineLite } from 'gsap'
import HomeSearchResults from '@/components/HomeSearchResults'
import ScrollIndicator from '@/components/ScrollIndicator'
import shuffle from 'shuffle-array'
import i18n from "@/i18n";

export default {
  mixins: [customTransitionMixins],
  name: 'home',
  props: {
    searchMode: {
      type: Boolean,
      required: true
    }
  },
  components: {
    FooterDonation,
    BackgroundRelief,
    SvgInline,
    PageTitle,
    CoverSection,
    PageTransitionLayer,
    HomeSearchResults,
    SearchListResults,
    ScrollIndicator
  },
  data () {
    return {
      SPEED,
      COLOR,
      samples: null,
      tour: null,
      overItem: null,
      isTransitioning: true,
      selectedItem: null,
      searchModeReady: true,
      scrollProgress: 0,
      isBackgroundReliefInit: false,
      isPageContentInit: false,
      isHomeSearchResultsfInit: false
    }
  },
  computed: {
    ...mapGetters(['searchQuery']),
    apiKey () {
      return process.env.VUE_APP_ALOGLIA_API_KEY
    },
    appId () {
      return process.env.VUE_APP_ALOGLIA_APP_ID
    },
    indexName () {
      return process.env.VUE_APP_ALOGLIA_INDEX_NAME
    },
    currentItem () {
      return this.overItem || this.selectedItem
    }
  },
  watch: {
    isTransitioning () {
      if (!this.isTransitioning) {
        this.$nextTick(() => this.afterTransitionIn())
      }
    },
    searchMode () {},
    searchModeReady () {}
  },
  beforeRouteEnter (to, from, next) {
    Vue.$api.getHome(i18n.locale).then((response) => {
      next((vm) => {
        vm.setData(response.data)
      })
    })
  },
  mounted () {
    this.searchModeReady = this.searchMode
  },
  methods: {
    setData (data) {
      const originalSamples = data.promoted_samples.map((p) => {
        return new SampleModel(p)
      })
      let manySamples = []

      // TODO - enlevé ça une fois qu'il y a assez de résultats
      // On fabrique une très longue liste de samples !
      // 0 fois le nombre actuel de samples diférents
      for (let i = 0; i < 6; i++) {
        manySamples = [...manySamples, ...originalSamples]
      }
      shuffle(manySamples) // Mélange les samples

      this.samples = manySamples
      this.tour = data.promoted_tour
    },
    /**
     * Callback lorsque le progress du scroll de HomeSearchResults change
     */
    scrollProgressChangedHandler (scrollProgress) {
      this.scrollProgress = scrollProgress
    },
    transitionSearchModeCompletedHandler () {
      this.searchModeReady = this.searchMode
    },
    mouseenterItemHandler (item) {
      this.overItem = item
    },
    mouseleaveItemHandler (item) {
      if (this.overItem === item) {
        this.overItem = null
      }
    },
    selectedItemUpdateHandler (item) {
      this.selectedItem = item
    },
    /**
     * Override la méthode transitionIn de customTransitionMixins
     * Afin de définir une animation custom
     *
     * @args {Function} ended - callback à appeler une fois l'animation terminée
     */
    transitionIn (next) {
      const timeline = new TimelineLite({
        onComplete: () => {
          // On défini qu'on est plus en transition
          this.isTransitioning = false

          next()
        }
      })

      this.isTransitioning = true

      // Simple delay permettant de voir le layer de transition
      // avant l'animation des différents composants de la page
      timeline.delay(this.SPEED.NORMAL)
    },
    /**
     * Animation des composant secondaires
     * après apparition de la page
     */
    afterTransitionIn () {
      const {
        discoverLink,
        unilasalleLogo,
        footerDonation,
        resultsList
      } = this.$refs
      const timeline = new TimelineLite()

      timeline.call(() => {
        this.isHomeSearchResultsfInit = true
      })

      timeline.call(
        () => {
          this.isPageContentInit = true
        },
        null,
        null,
        `+=${this.SPEED.NORMAL}`
      )

      timeline.call(
        () => {
          this.isBackgroundReliefInit = true
        },
        null,
        null,
        `+=${this.SPEED.NORMAL}`
      )
    }
  }
}
</script>

<style lang="stylus">

.Home

  // &_content

  //   pointer-events none

  .UnilasalleLogo
    position absolute
    bottom 20px
    left 20px
    width 70px
    color $beige-l

    svg
      width 100%

    @media $mq_m
      bottom 40px
      left 40px
      width 90px

    @media $mq_l
      width 134px
      opacity .3

    @media $mq_xl
      bottom 50px
      left 65px

  .DiscoverLink

    position absolute
    bottom 170px
    left 130px
    max-width 270px
    color white
    z-index 2
    text-decoration none

    @media $mq_s_only

      display none

    rect

      transition all 0.8s $ease
      transform-origin center right
      position relative

    &:hover

      .DiscoverLink_value

        opacity 0.3

      rect

        transform scaleX(0.5)

    &_title

        opacity: 0.3;
        font-weight 700
        font-size: 14px;
        text-transform uppercase
        letter-spacing: 2px;

    .sep

        background-color white
        margin-left 0px
        opacity 0.3

    &_value

      font-weight 200
      font-size: 24px;
      line-height: 30px;
      transition all 1s $ease

    svg

        margin-top 20px
        width 90px
</style>
